import React from "react";
import classnames from 'classnames';
import { disabledCountries } from '../../../utils'

import CheckBoxCommon from '../../common/Checkbox/Checkbox';

export const CheckBox = props => {
  let associations = props.associations ? [...props.associations] : [];
  let count = 0;
  let ukCount = 0
  let subChkDisbleData = props.disabledData.map(item => { if (item.hasOwnProperty('basicDetails') && item.basicDetails.paymentTypes.length > 0 && props.selectedCaseId === item.caseId) { return item.basicDetails; } })
  let disabledItem;
  if (props.isCType !== undefined && props.isCType === true) {
    disabledItem = props.disabledData.some((item) => { if (item.country.value === props.id && props.selectedCaseId !== undefined && props.selectedCaseId !== '' && props.selectedCaseId === item.caseId) { return true; } else { return false; } });
  } else {
    disabledItem = props.disabledData.some((item) => { if (item.country.value === props.id && props.id.split(':')[7] !== "UnitedKingdom-HSBCBankplc" && props.id.split(':')[7] !== "UnitedKingdom-HSBCUK" && props.selectedCaseId !== undefined && props.selectedCaseId !== '' && props.selectedCaseId === item.caseId) { return true; } else { return false; } });
  }
  subChkDisbleData = subChkDisbleData.filter(item => item);
  let disbableSubchek;

  if (props.isChecked === false) {
    associations.map(item => (item.isChecked = false));
  }

  props.disabledData.map((_item) => {
    if (_item.country.value === props.id && props.selectedCaseId !== undefined && props.selectedCaseId !== '' && props.selectedCaseId === _item.caseId && _item.paymentType !== undefined) {
      if ((_item.paymentType.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCBankplc:newDca:EN" ||
        _item.paymentType.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCBankplc:transferOfSponsorshipIndirect:EN" ||
        _item.paymentType.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCBankplc:transferOfSponsorshipDca:EN" ||
        _item.paymentType.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCBankplc:newDirect:EN" ||
        _item.paymentType.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCBankplc:newInDirect:EN" ||
        _item.paymentType.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCBankplc:transferOfSponsorshipDirect:EN")) {
        return count += 1;
      } else if ((_item.paymentType.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCUK:newDca:EN" ||
        _item.paymentType.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCUK:transferOfSponsorshipIndirect:EN" ||
        _item.paymentType.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCUK:transferOfSponsorshipDca:EN" ||
        _item.paymentType.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCUK:newDirect:EN" ||
        _item.paymentType.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCUK:newInDirect:EN" ||
        _item.paymentType.value === "urn:hsbc:cmb:gdocs:products:taxonomies:countries:UnitedKingdom-HSBCUK:transferOfSponsorshipDirect:EN")) {
        return count += 1;
      }
    }
  })

  const checkDisabledItem = () => {
    if (props.productType === "cashFlowForecasting") {
      const option = Array.isArray(props.selectedCheckBox) && props.selectedCheckBox.length ? props.selectedCheckBox[0] : {}
      if (option.id) {
        return !(props.id === option.id)
      } else if (disabledItem) {
        return true
      } else {
        return false
      }
    }
    return disabledItem

  }

  const isDisabled = (disabledCountries.indexOf(props.name) >= 0) || checkDisabledItem()
  return (
    <div className="checkbox__item clearfix">
      <CheckBoxCommon
        id={props.id}
        onChange={props.handleCheckElement}
        type="checkbox"
        checked={props.isChecked}
        name={props.id}
        className={classnames({ 'disable-item': isDisabled })}
        disabled={isDisabled}
        controlled
      />
      <label
        htmlFor={props.id}
        className={classnames({ 'disable-item': isDisabled })}
      >
        {props.name}
      </label>

      {(props.isChecked && props.isAssociation &&
        associations.length > 0 &&
        associations.map((opt, i) =>
        (
          <div className="checkbox__item__sub clearfix" key={i}>
            <CheckBoxCommon
              id={opt.id}
              onChange={props.handleSubCheckbox}
              type="checkbox"
              checked={opt.isChecked}
              name={opt.id}
              controlled
              className={classnames({ 'disable-item': disbableSubchek === true })}
            />
            <label htmlFor={opt.id} className={classnames({ 'disable-item': disbableSubchek === true })}>{opt.name}</label>
          </div>
        )
        )
      )}
    </div>
  );
};

export default CheckBox;



// WEBPACK FOOTER //
// ./src/components/common/NestedCheckBox/CheckBox.js